var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppWindowCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0135 13.004V3.00397C29.0135 2.47353 28.8028 1.96483 28.4278 1.58975C28.0527 1.21468 27.544 1.00397 27.0135 1.00397H3.01355C2.48312 1.00397 1.97441 1.21468 1.59934 1.58975C1.22426 1.96483 1.01355 2.47353 1.01355 3.00397V25.004C1.01355 25.5344 1.22426 26.0431 1.59934 26.4182C1.97441 26.7932 2.48312 27.004 3.01355 27.004H11.0135",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01355 7.00397H29.0135",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0136 23.004C31.0136 24.5862 30.5444 26.1329 29.6653 27.4485C28.7863 28.7641 27.5368 29.7895 26.075 30.395C24.6132 31.0005 23.0047 31.1589 21.4528 30.8503C19.901 30.5416 18.4755 29.7796 17.3567 28.6608C16.2379 27.542 15.476 26.1165 15.1673 24.5647C14.8586 23.0128 15.017 21.4043 15.6225 19.9425C16.228 18.4807 17.2534 17.2313 18.569 16.3522C19.8846 15.4732 21.4313 15.004 23.0136 15.004",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0136 17.004L23.7202 24.2973C23.6274 24.3902 23.5171 24.464 23.3957 24.5142C23.2743 24.5645 23.1443 24.5904 23.0129 24.5904C22.8815 24.5904 22.7514 24.5645 22.6301 24.5142C22.5087 24.464 22.3984 24.3902 22.3055 24.2973L20.0135 22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppWindowCheck);
export default __webpack_public_path__ + "static/media/AppWindowCheck.9a15a65eca97bd283648cf81123db33c.svg";
export { ForwardRef as ReactComponent };